import type { Locale, LocalizedString } from "../schema/Locale.js";

export function translate<Translations extends Record<string, LocalizedString>, Key extends keyof Translations>(
	translations: Translations,
	key: Key,
	t: Locale,
	variables: Record<string, string | number> = {},
): Translations[Key][Locale] {
	const translation = translations[key]?.[t];
	let finalTranslation = String(translation ?? key);
	for (const [variable, value] of Object.entries(variables)) {
		finalTranslation = finalTranslation.replaceAll(`{{${variable}}}`, String(value));
	}
	return finalTranslation as Translations[Key][Locale];
}
